<template>
  <v-container
    id="password-view"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="12">
        <v-slide-y-transition appear>
          <material-card
            light
            max-width="350"
            rounded
            class="mx-auto"
            color="accent"
            full-header
          >
            <template #heading>
              <div class="text-center pa-5">
                <div class="text-h4 font-weight-bold white--text">
                  {{ $t('reset_password') }}
                </div>
              </div>
            </template>

            <v-card-text class="text-center">
              <validation-provider
                v-slot="{ errors }"
                name="password"
                rules="required"
              >
                <v-text-field
                  v-model="password"
                  class="mb-4"
                  :error-messages="errors"
                  :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="show ? 'text' : 'password'"
                  color="secondary"
                  :placeholder="$t('password')+'...'"
                  prepend-icon="mdi-lock-outline"
                  @click:append.prevent="show = !show"
                />
              </validation-provider>

              <v-col class="py-0">
                <v-btn
                  v-shortkey.once="['enter']"
                  color="accent"
                  rounded
                  text
                  large
                  @shortkey="clickResetPassword"
                  @click="clickResetPassword"
                >
                  {{ $t('change_password') }}
                </v-btn>
              </v-col>
              <v-btn
                color="accent"
                rounded
                large
                icon
                @click="backToLogin"
              >
                <v-icon v-text="'$login'" />
              </v-btn>
            </v-card-text>
          </material-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  // Utilities
  import { call, dispatch, get } from 'vuex-pathify'

  export default {
    name: 'ResetPasswordView',
    data () {
      return {
        error: false,
        show: false,
        token: '',
        password: '',
        loading: false,
      }
    },
    computed: {
      logged_in: get('auth/logged_in'),
      // user: get('auth/user'),
    },
    mounted () {
      this.token = this.$route.params.token
    },
    methods: {
      resetPassword: call('auth/resetPassword'),
      clickResetPassword () {
        this.error = false
        this.resetPassword({
          remember_token: this.token,
          password: this.password,
        }).then(response => {
          dispatch('alert/setSnackbar', { text: this.$t('password_reset_success'), type: 'success' })
          // this.$router.push('/login').catch(() => {})
        }).catch(e => {
          console.log(e)
          self.error = true
        })
      },
      backToLogin () {
        this.$router.push('/login').catch(() => {})
      },
    },
  }
</script>
